import axiosInstance from "../../../utils/axios";

const path = "/website";

export const ContactUsForm = async (values) => {
  return await axiosInstance().post(`${path}/contact-us-form`, values);
};

export const GetAllFAQ = async (values) => {
  return await axiosInstance().get(`${path}/faq`, values);
};

export const CMSPageDetails = async (values) => {
  return await axiosInstance().get(`${path}/cms-page?page_slug=${values}`);
};

export const GetGlobalSettings = async () => {
  return await axiosInstance().get("/common/global-settings");
};
